<template>
    <div class="panel-list-new panel-content">
        <div class="row review-component">
            <b-card class="col-lg-12 main-content" v-cloak>
                <div class="panel-list">
                    <div class="panel-body">
                        <b-row class="panel-title">
                            <label :class="'col-' + ColumnsClass">Agency/HFM Info</label>
                        </b-row>
                        <b-row class="panel-content">
                            <b-col :cols="ColumnsClass">
                                <label>Legal Entity</label>
                                <p>{{ReportingEntityRequestDetail.EntityName}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>AGENCY</label>
                                <p>{{ReportingEntityRequestDetail.AgencyName}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>Location</label>
                                <p>{{ReportingEntityRequestDetail.Location}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>Department</label>
                                <p>{{ReportingEntityRequestDetail.Department}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>Suggested Entity</label>
                                <p>{{ReportingEntityRequestDetail.SuggestedEntity}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>HFM Entity/Hyperion</label>
                                <p>{{ReportingEntityRequestDetail.HFMEntity}}</p>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="panel-body">
                        <b-row class="panel-title">
                            <label :class="'col-' + ColumnsClass">Reporting Info</label>
                        </b-row>
                        <b-row class="panel-content">
                            <b-col :cols="ColumnsClass">
                                <label>Is this a change in existing reporting entity?</label>
                                <p>{{ReportingEntityRequestDetail.IsChangeInReportingEntity == true ? 'YES' : 'NO'}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass" v-if="ReportingEntityRequestDetail.IsChangeInReportingEntity === false">
                                <label>Is there media associated with this new reporting entity?</label>
                                <p>{{ReportingEntityRequestDetail.IsMediaAssociated == true ? 'YES' : 'NO'}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass" v-if="ReportingEntityRequestDetail.IsMediaAssociated === true && ReportingEntityRequestDetail.IsChangeInReportingEntity === false">
                                <label>Is there an existing media office already set up in MO?</label>
                                <p>{{ReportingEntityRequestDetail.IsMediaOfficeSetUpInMO == true ? 'YES' : 'NO'}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass" v-if="ReportingEntityRequestDetail.IsChangeInReportingEntity === false">
                                <label>Will this reporting entity be required in Reach?</label>
                                <p>{{ReportingEntityRequestDetail.IsRequiredInReach == true ? 'YES' : 'NO'}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass" v-if="ReportingEntityRequestDetail.IsChangeInReportingEntity == true">
                                <label>Please indicate the current HFM entity that this maps to.</label>
                                <p>{{ReportingEntityRequestDetail.CurrentHFMEntity}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass" v-if="ReportingEntityRequestDetail.IsChangeInReportingEntity === true">
                                <label>Also, please indicate any existing alternate subsets or roll ups you need this removed from</label>
                                <p>{{ReportingEntityRequestDetail.ExistingRollupsToRemove}}</p>
                            </b-col>
                            <b-col :cols="ColumnsClass">
                                <label>If you would like this to be included in any alternate subsets or roll ups please indicate here</label>
                                <p>{{ReportingEntityRequestDetail.AlternateSubsetsOrRollups}}</p>
                            </b-col>                                               
                        </b-row>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    },
    props: {
        ReportingEntityRequestDetail: {
            required: false,
            type: Object,
            default() {
                return {}
            }
        },
        ID: {
            type: Number,
            required: false,
            default: 0,
        },
        IsAuditTrail: {
            required: false,
            type: Boolean,
            default: false,
        },
        Columns: {
            type: Number,
            default: 4,
            required: false,
        },
    },
    computed: {
        ColumnsClass() {
            return `lg-${this.Columns}`;
        },
    },
};
</script>

<style scoped>
.panel-list:not(.media-dropdowns) {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
}

.panel-list .panel-body .panel-title {
    border-bottom: 1px solid rgba(151, 151, 151, 0.2);
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px !important;
}

.panel-list .panel-body .panel-title label {
    color: #77a2bb;
    margin-bottom: 0px !important;
    padding-top: 13px !important;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.57;
    letter-spacing: normal;
    padding-left: 0px !important;
    min-height: 35px;
}

.panel-list .panel-body .panel-title .btn {
    padding-left: 5px;
    padding-right: 5px;
}

.panel-list .panel-body .panel-title>div {
    padding-right: 0px !important;
    float: right;
    font-family: "Open Sans";
    font-size: 12px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.75;
    letter-spacing: normal;
    color: #00a1d2;
}

.panel-list .panel-content label {
    text-transform: uppercase;
    color: #2c3865;
    font-size: 12px;
    margin-bottom: 1px !important;
    padding-left: 0px;
}

.panel-list .panel-content p {
    text-transform: uppercase;
    color: #4d5161;
    font-size: 14px;
    font-weight: 600;
}

.panel-content.row>div>label:first-child {
    color: #A2A9AD !important;
    font-family: "Open Sans" !important;
    font-size: 10px;
    font-weight: 600 !important;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.42;
    letter-spacing: normal;
}

.panel-content.row>div> :not(:first-child) {
    font-family: "Open Sans" !important;
    font-size: 14px !important;
}

.panel-content.row>div>div {
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: #4d5161;
}

.panel-list>.panel-body {
    margin-top: 1rem !important;
}

.panel-content.row>div {
    margin-bottom: 10px !important;
}

.edit-icon {
    height: 11px;
    width: 11px;
    color: #00a1d2;
}
</style>
